<template>
  <svg class="animate-spin" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M103 53C103 80.6142 80.6142 103 53 103C25.3858 103 3 80.6142 3 53C3 25.4292 25.3154 3.07048 52.8697 3.00017"
      stroke="currentColor"
      stroke-width="5"
    />
  </svg>
</template>
